import React from "react";
import {
    FormControl,
    Select,
    MenuItem,
} from "@mui/material";
import { AddButton } from "../../Common";
import { trakrefFontFamily } from "../../../utils"
import UserInfo from "../../../UserInfo";
import Enums from "../../../enums";

const { UserTypes } = Enums;

const AddUserButton = (
    {
        openMenu = false,
        history = {},
        onOpen = () => {},
        onClose = () => {},
        customButton = null,
    }
) => {
    const techOrTechManager = (
        UserInfo.isNativeSystemOwner() && (
            UserInfo.isSystemAdministrator() ||
            UserInfo.isSuperTenantAdmin() ||
            UserInfo.isTenantAdministrator() ||
            UserInfo.isRegionalAdministrator() ||
            UserInfo.isTechnicianManager()
        )
    ) || (
        UserInfo.isNativeServiceProvider() && (
            UserInfo.isTenantAdministrator() ||
            UserInfo.isTechnicianManager()
        )
    );

    const regional = (
        UserInfo.isSystemAdministrator() || (
            UserInfo.isSystemOwner() && (
                UserInfo.isSuperTenantAdmin() ||
                UserInfo.isTenantAdministrator() ||
                UserInfo.isRegionalAdministrator()
            )
        )
    );

    const tenant = (
        UserInfo.isNativeSystemOwner() &&
        (
            UserInfo.isSystemAdministrator() ||
            UserInfo.isSuperTenantAdmin() ||
            UserInfo.isTenantAdministrator() ||
            UserInfo.isRegionalAdministrator()
        )
    ) || (
        UserInfo.isNativeServiceProvider() &&
        UserInfo.isTenantAdministrator()
    );
    
    return (
        <div
            style={{
                position: "relative",
            }}
        >
            {customButton && customButton}

            {!customButton && (
                <AddButton text={"Add User"} onClick={onOpen} />
            )}

            <FormControl
                size="small"
                sx={{
                    minWidth: 100,
                    bottom: "-1px",
                    position: "absolute",
                    right: "0",
                    clip: "rect(0 0 0 0)",
                    clipPath: "inset(50%)",
                }}
            >
                <Select
                    variant="filled"
                    open={openMenu}
                    onClose={onClose}
                    onOpen={onOpen}
                    onChange={(e) => {
                        history.push(`/UserAdd?usertype=${e.target.value}`, null);
                    }}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        },
                        sx: {
                            "& .MuiList-root": {
                                padding: "10px 0px 10px 0px",
                            },
                            "& .MuiMenuItem-root": {
                                padding: "2px 10px 2px 10px",
                                fontSize: "12px",
                                fontFamily: trakrefFontFamily,
                                fontWeight: "600 !important",
                                letterSpacing: "1.2",
                                color: "#22252B",
                            },
                        },
                    }}
                >
                    <MenuItem value={UserTypes.ReadOnly}>Add Read-Only</MenuItem>
                    {(UserInfo.isSystemAdministrator() || regional) && <MenuItem value={UserTypes.RegionalAdministrator}>Add Regional Administrator</MenuItem>}
                    {(UserInfo.isSystemAdministrator() || techOrTechManager) && <MenuItem value={UserTypes.Technician}>Add Technician</MenuItem>}
                    {(UserInfo.isSystemAdministrator() || techOrTechManager) && <MenuItem value={UserTypes.TechnicianManager}>Add Technician Manager</MenuItem>}
                    {(UserInfo.isSystemAdministrator() || tenant) && <MenuItem value={UserTypes.TenantAdministrator}>Add Tenant Administrator</MenuItem>}
                    {tenant && <MenuItem value={UserTypes.APIFacilityManager}>Add API User - Facility Manager</MenuItem>}
                    {(UserInfo.isSystemAdministrator() || UserInfo.isNativeSuperTenantAdministrator()) && (
                        <MenuItem value={UserTypes.SuperTenantAdmin}>Add Super Tenant Administrator</MenuItem>
                    )}
                </Select>
            </FormControl>
        </div>
    );
};

export default AddUserButton;